<template>
  <div>
    <gmap-marker
      :position="position"
      :label="{
        text: sequenceNumber.toString(),
        color: 'white',
        fontSize: '16px'
      }"
      :icon="markerIcon"
    />
  </div>
</template>

<script>
export default {
  name: "GoogleMapWaypoint",
  props: {
    position: {
      type: Object,
      required: true
    },
    sequenceNumber: {
      type: Number,
      required: true
    },
    totalWaypoints: {
      type: Number,
      required: true
    }
  },
  computed: {
    markerIcon() {
      let colorUrl;
      if (this.sequenceNumber === 1) {
        colorUrl = "/img/green-circle.png";
      } else if (this.sequenceNumber === this.totalWaypoints) {
        colorUrl = "/img/red-circle.png";
      } else {
        colorUrl = "/img/blue-circle.png";
      }

      return {
        url: colorUrl,
        size: new window.google.maps.Size(30, 30),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(10, 10)
      };
    }
  }
};
</script>
